export { default } from './UpdatePhoneModal.component';
